import React from 'react';
import {
  graphql,
  createRefetchContainer,
} from 'react-relay';

import { withRouter } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import { Link } from '@material-ui/core';
import { useCommonStyles } from '../common/Styles';
import TableFieldMeta from '../../common/TableFieldMeta';
import InnerTabFilterGridItemTextField from '../common/innerTab/InnerTabFilterGridItemTextField';
import BaseGridContainer from '../common/BaseGridContainer';
import TablePaginator from '../common/TablePaginator';
import { createQueryRendererProgressV2 } from '../common/QueryRendererProgressV2';
import InnerTabFilterSelectField from '../common/innerTab/InnerTabFilterSelectField';

const matchedDefault = false;
const ignoreDefault = false;

function CSReportList(props) {
  const { viewer, relay, filter } = props;
  filter.setRelay(relay);
  const classes = useCommonStyles();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [reportType, setReportType] = React.useState(filter.params.type);
  const columns = [
    TableFieldMeta.localId,
    TableFieldMeta.createdAt,
    // TableFieldMeta.enum('CSReportType', 'Type', node => node.type),
    TableFieldMeta.field('type', 'Type'),
    TableFieldMeta.fieldCell('fileUrl', 'File', (row) => {
      if (!row.value.contentUrl) {
        return null;
      }
      return <Link href={row.value.contentUrl}>{row.value.content}</Link>;
    }, { accessor: x => x }),
    TableFieldMeta.field('fileName', 'Name'),
  ];

  return (
    <div className={classes.innerTabRoot}>
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <div
          tabIndex={0}
          role="button"
        >
          {/*<ProcessForm brokerActivity={brokerActivity} close={() => setDrawerOpen(false)} />*/}
        </div>
      </Drawer>

      <BaseGridContainer>
        <InnerTabFilterGridItemTextField
          id="search-filter"
          label="Custom Search"
          defaultValue={filter.params.search}
          helperText="description, symbol"
          onChange={e => filter.updateVar('search', e.target.value)}
        />
        
        {/*<InnerTabFilterToggleButtonGroup*/}
        {/*  enumType="CSReportType"*/}
        {/*  helperText="Type"*/}
        {/*  defaultValue="MT536"*/}
        {/*  onChange={newVal => filter.updateVar('matched', newVal)}*/}
        {/*/>*/}

        <InnerTabFilterSelectField
          enumType="CSReportType"
          label="Type"
          // useCaption
          value={reportType}
          onChange={(e) => {
            setReportType(e.target.value);
            filter.updateVar('type', e.target.value);
          }}
        />

        <Grid item xs={12}>
          <TablePaginator
            filter={filter}
            columns={columns}
            getDataNode={() => (viewer ? viewer.clearstreamReports : null)}
            // tableRender={RTTableRenderer}
          />
        </Grid>
      </BaseGridContainer>
    </div>
  );
}

const query = graphql`
  query CSReportListQuery (
    $first: Int
    $offset: Int
    $search: String
    $type: String
  ) {
    viewer {
      ...CSReportList_viewer
      @arguments (
        first: $first
        offset: $offset
        search: $search
        type: $type
      )
    }
  }
`;

const container = createRefetchContainer(
  CSReportList,
  {
    viewer: graphql`
      fragment CSReportList_viewer on Query
      @argumentDefinitions(
        first: {type: Int, defaultValue: 10}
        offset: {type: Int}
        search: {type: String}
        type: {type: String}
      ) {
        clearstreamReports(
          first: $first
          offset: $offset
          search: $search
          type: $type
          orderBy: "-createdAt"
        ) {
          edges {
            node {
              id
              createdAt
              updatedAt
              fileName
              xmlIdentifier
              type
              content
              contentUrl
            }
          }
          count
        }
      }
    `,
  },
  query,
);

export default withRouter(createQueryRendererProgressV2(
  query,
  container,
  {},
  () => ({
    search: null,
    reportDate: null,
    matched: matchedDefault,
    ignore: ignoreDefault,
  }),
  {
    debounceFields: ['search'],
  },
));
